import Layout from "app/components/layout";
import Sprite from "app/components/sprite";
import meydanLogo from "app/images/logos/meydan.png";
import Link from "app/components/i18n/Link";
import { Trans, useTranslation } from "react-i18next";
import { getLoaderTrans } from "app/.server/utils";
import { getMeta } from "app/utils/meta";

export const loader = async ({ request, params }) => {
  const trans = await getLoaderTrans({ request, params });

  return {
    meta: {
      title: `${trans("Partnerships")} | Zbooni`,
    },
  };
};

export const meta = ({ loaderData: data }) => {
  return getMeta({
    title: data.meta.title,
  });
};

export default function PartnershipsPage() {
  const { t: trans } = useTranslation();

  const partners = [
    {
      name: trans("Meydan Free Zone Partnership"),
      description: trans(
        "Zbooni has partnered with Meydan Free Zone to make it easier for you to renew or get a new business license. Meydan Free Zone allows you to design the license that fits your business needs and it’s 100% digital. You can do it all online and hassle-free!"
      ),
      icon: meydanLogo,
      link: "/partnerships/meydan",
    },
  ];

  return (
    <Layout headerIsOnTop={false} enableHeaderShrinkingOnScroll={false}>
      <header className="bg-primary ">
        <div className="zbooni-layout pt-24 h-72 relative overflow-hidden">
          <Sprite
            name="donut"
            fill="#FFF"
            className="absolute opacity-[.08] w-[230px] md:w-[442px] h-[230px] md:h-[442px] top-28 md:top-20 ltr:-right-6 ltr:md:right-0 rtl:-left-6 rtl:md:left-0"
          />
          <h1 className="text-2xl font-extrabold text-white xs:text-[28px] sm:text-[32px]">
            <Trans>Partnerships</Trans>
          </h1>
        </div>
      </header>
      <div className="bg-white">
        <div className="zbooni-layout">
          <div className="relative -top-32 md:-top-24 flex flex-col gap-10">
            {partners.map((partner) => (
              <Link
                to={partner.link}
                key={partner.link}
                className="lg:h-96 md:h-80 bg-white shadow-card-md rounded-3xl p-5 lg:p-9 flex gap-8 lg:gap-14 md:pointer-events-none"
              >
                <div className="flex flex-col gap-5 lg:gap-10 justify-center w-full md:w-6/12 lg:w-7/12">
                  <p className="text-xl lg:text-[28px] font-extrabold leading-8">
                    {partner.name}
                  </p>
                  <div className="flex md:hidden my-auto lg:my-0 flex-1 justify-center border rounded-lg">
                    <img
                      src={partner.icon}
                      alt={partner.name}
                      className="p-5 object-contain mx-auto"
                    />
                  </div>
                  <p className="text-sm lg:text-base">{partner.description}</p>
                  <Link
                    to={partner.link}
                    className="md:block hidden pointer-events-auto"
                  >
                    <button className="dark-green-gradient-btn rounded-full py-2 lg:py-4">
                      <p className="text-sm lg:text-base">
                        <Trans>Learn More</Trans>
                      </p>
                    </button>
                  </Link>
                </div>
                <div className="hidden md:block lg:flex my-auto lg:my-0 flex-1 justify-center border rounded-lg">
                  <img
                    src={partner.icon}
                    alt="shapes defined"
                    className="p-5 object-contain mx-auto"
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
